export const DIFFICULTY_DC = {
  trivial: 5,
  easy: 10,
  medium: 15,
  hard: 20,
  deadly: 25
};
